import { useTranslation } from 'react-i18next';
import { overwriteDisplay } from '@/displays/displays.actions';
import { SimpleSaveFormBuilder } from '@/formbuilder/SimpleSaveFormBuilder.page';
import { doTrack } from '@/track/track.service';
import { Modal } from '@seeqdev/qomponents';
import type { FormElement } from '@/formbuilder/formBuilder.constants';

interface OverwriteDisplayModalProps {
  onClose: () => void;
  display: {
    id: string;
    name: string;
    type: string;
    ancestors: { id: string }[];
  };
  displaysCount: number;
}

export const OverwriteDisplayModal = ({ onClose, display, displaysCount }: OverwriteDisplayModalProps) => {
  const { t } = useTranslation();

  const formDefinition: FormElement[] = [
    {
      component: 'LabelFormComponent',
      name: 'overwriteDisplayLabel',
      value: 'DISPLAYS.MODAL.OVERWRITE.BODY_DISPLAY',
      valueCustomParams: { ITEM_NAME: display.name },
    },
    {
      component: 'LabelFormComponent',
      name: 'renameDisplayWarning',
      value: 'DISPLAYS.MODAL.MULTIPLE_DISPLAY_WARNING',
      valueCustomParams: { SCALE_COUNT: displaysCount - 1 },
      extraClassNames: 'text-italic',
      includeIf: displaysCount > 1,
    },
  ];

  /**
   * Resets the current workstep of the display and all scaled displays to the current workstep
   *
   * @returns {Promise} that resolves when the update is complete
   */
  function trackAndOverwriteDisplay() {
    doTrack('Search results', 'Overwrite Display', `overwrite display item ${display.name}`);
    return overwriteDisplay(display).then(() => {
      onClose();
    });
  }

  return (
    <Modal
      open={true}
      onClose={onClose}
      testId="overwriteDisplayModal"
      title={t('DISPLAYS.MODAL.OVERWRITE.TITLE')}
      hideFooterButtons={true}>
      <div data-testid="overwriteDisplayModalBody">
        <SimpleSaveFormBuilder
          testId="overwriteSimpleSaveFormBuilder"
          formDefinition={formDefinition}
          submitFn={trackAndOverwriteDisplay}
          closeFn={onClose}
          submitBtnLabel="SEARCH_DATA.DISPLAYS.OVERWRITE"
        />
      </div>
    </Modal>
  );
};
